import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SpecStrat } from '../models/SpecStrat';
import {
  Location,
  NavigateFunction,
  useLocation,
  useNavigate
} from 'react-router-dom';
import { Dispatch } from '@reduxjs/toolkit';

export type Web3InteractionDecisionRq<DataStoreType> = {
  dataStore: DataStoreType;
  dispatch: Dispatch<any>;
  vestingContractAddress?: string;
  location: Location;
  navigate: NavigateFunction;
  error: string;
};
export type Web3InteractionHookReturnValues = {
  activeStep: number;
};

export const useWeb3Interaction = <DataStoreType,>(
  dataStore?: DataStoreType,
  vestingContractAddress?: string,
  decisions?: SpecStrat<Web3InteractionDecisionRq<DataStoreType>, number>[],
  error?: string
): Web3InteractionHookReturnValues => {
  const [activeStep, setActiveStep] = useState(0);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const canFindNextDecision = dataStore && vestingContractAddress;
    if (canFindNextDecision) {
      const decisionRq: Web3InteractionDecisionRq<DataStoreType> = {
        dispatch,
        vestingContractAddress,
        error,
        dataStore,
        location,
        navigate
      };
      const result = decisions.find((decision) =>
        decision.evaluateCondition(decisionRq)
      );

      if (result) {
        setActiveStep(result?.executeAction(decisionRq));
      }
    }
  }, [dataStore, vestingContractAddress, error]);
  return {
    activeStep
  };
};
